// extracted by mini-css-extract-plugin
export default {"star":"rHFqD9-yY1-eIMAm4ESQC"};